// extracted by mini-css-extract-plugin
module.exports = {"summaryValue":"SummaryValue_summaryValue__3bMd3","bullet":"SummaryValue_bullet__3pFvo"};